// components/MeetingHeader.jsx
import React from "react";
import { toNormalText } from "../utils/helpers";

const MeetingHeader = ({ selectedUser, isVideoMeeting, setIsVideoMeeting, selectedMeetingMode, setSelectedMeetingMode, startingMeeting, handleConfirmStartMeeting, closeStartMeetingPopup }) => {
  const getContextConfig = (mode) => {
    switch (mode) {
      case "video_call":
        return {
          meetingContext: "video_call",
          captureModes: { wearables: true, voice: true, camera: true },
        };
      case "audio_call":
        return {
          meetingContext: "audio_call",
          captureModes: { wearables: true, voice: true, camera: false },
        };
      case "verbal_audio":
        return {
          meetingContext: "verbal_audio",
          captureModes: { wearables: true, voice: true, camera: false },
        };
      case "in_person":
      default:
        return {
          meetingContext: "in_person",
          captureModes: { wearables: true, voice: true, camera: false },
        };
    }
  };

  return (
    <div
      className="meeting-popup-overlay"
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.55)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        padding: 16,
      }}
    >
      <div
        className="meeting-popup-card"
        style={{
          width: "100%",
          maxWidth: 520,
          background: "#1f1f24",
          border: "1px solid rgba(255,255,255,0.12)",
          borderRadius: 16,
          padding: 20,
          color: "#fff",
          boxShadow: "0 10px 30px rgba(0,0,0,0.35)",
        }}
      >
        <h3 style={{ marginTop: 0, marginBottom: 12 }}>Start Meeting</h3>
        <p style={{ marginTop: 0, opacity: 0.9 }}>
          Meeting with <b>{selectedUser?.first_name} {selectedUser?.last_name}</b>
        </p>

        <div style={{ marginTop: 16 }}>
          <p style={{ marginBottom: 10 }}><b>Is this a Video meeting?</b></p>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button
              type="button"
              className="toggle-btn"
              onClick={() => {
                setIsVideoMeeting(true);
                setSelectedMeetingMode("video_call");
              }}
              style={{
                padding: "8px 14px",
                borderRadius: 999,
                border: "1px solid rgba(255,255,255,0.14)",
                background: isVideoMeeting === true ? "rgba(255,255,255,0.12)" : "transparent",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              Yes
            </button>
            <button
              type="button"
              className="toggle-btn"
              onClick={() => {
                setIsVideoMeeting(false);
                setSelectedMeetingMode("in_person");
              }}
              style={{
                padding: "8px 14px",
                borderRadius: 999,
                border: "1px solid rgba(255,255,255,0.14)",
                background: isVideoMeeting === false ? "rgba(255,255,255,0.12)" : "transparent",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              No
            </button>
          </div>
        </div>

        {/* {isVideoMeeting === true && (
          <div style={{ marginTop: 18 }}>
            <p style={{ marginBottom: 10 }}><b>Select Meeting Type</b></p>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <button
                type="button"
                onClick={() => setSelectedMeetingMode("video_call")}
                className="toggle-btn"
                style={{
                  padding: "8px 14px",
                  borderRadius: 999,
                  border: "1px solid rgba(255,255,255,0.14)",
                  background: selectedMeetingMode === "video_call" ? "rgba(255,255,255,0.12)" : "transparent",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                Video Call
              </button>
              <button
                type="button"
                onClick={() => setSelectedMeetingMode("audio_call")}
                className="toggle-btn"
                style={{
                  padding: "8px 14px",
                  borderRadius: 999,
                  border: "1px solid rgba(255,255,255,0.14)",
                  background: selectedMeetingMode === "audio_call" ? "rgba(255,255,255,0.12)" : "transparent",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                Audio Only
              </button>
            </div>
          </div>
        )} */}

        {isVideoMeeting === false && (
          <div style={{ marginTop: 18 }}>
            <p style={{ marginBottom: 10 }}><b>Select normal meeting type</b></p>
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
              <button
                type="button"
                onClick={() => setSelectedMeetingMode("in_person")}
                className="toggle-btn"
                style={{
                  padding: "8px 14px",
                  borderRadius: 999,
                  border: "1px solid rgba(255,255,255,0.14)",
                  background: selectedMeetingMode === "in_person" ? "rgba(255,255,255,0.12)" : "transparent",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                In-person
              </button>
              <button
                type="button"
                onClick={() => setSelectedMeetingMode("verbal_audio")}
                className="toggle-btn"
                style={{
                  padding: "8px 14px",
                  borderRadius: 999,
                  border: "1px solid rgba(255,255,255,0.14)",
                  background: selectedMeetingMode === "verbal_audio" ? "rgba(255,255,255,0.12)" : "transparent",
                  color: "#fff",
                  cursor: "pointer",
                }}
              >
                Verbal / Audio
              </button>
            </div>
          </div>
        )}

        <div
          style={{
            marginTop: 20,
            padding: 12,
            borderRadius: 12,
            background: "rgba(255,255,255,0.04)",
            border: "1px solid rgba(255,255,255,0.08)",
          }}
        >
          <p style={{ margin: 0, marginBottom: 6 }}>
            <b>Selected Mode:</b> {toNormalText(selectedMeetingMode)}
          </p>
          <p style={{ margin: 0 }}>
            <b>Capture:</b>{" "}
            {(() => {
              const cfg = getContextConfig(selectedMeetingMode);
              const enabled = Object.entries(cfg.captureModes)
                .filter(([, v]) => v)
                .map(([k]) => toNormalText(k))
                .join(", ");
              return enabled || "None";
            })()}
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: 10,
            marginTop: 20,
          }}
        >
          <button
            type="button"
            onClick={closeStartMeetingPopup}
            style={{
              padding: "10px 16px",
              borderRadius: 10,
              border: "1px solid rgba(255,255,255,0.14)",
              background: "transparent",
              color: "#fff",
              cursor: "pointer",
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirmStartMeeting}
            disabled={isVideoMeeting === null || startingMeeting}
            style={{
              padding: "10px 16px",
              borderRadius: 10,
              border: "none",
              background: isVideoMeeting === null || startingMeeting ? "rgba(255,255,255,0.15)" : "#4f46e5",
              color: "#fff",
              cursor: isVideoMeeting === null || startingMeeting ? "not-allowed" : "pointer",
            }}
          >
            {startingMeeting ? "Starting..." : "Start Meeting"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MeetingHeader;